import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    FirstName: '',
    LastName: '',
    Email: '',
    AddressLine1: '',
    City: '',
    State: null,
    ZipCode: '',
    Phone: '',
    NewsletterOptIn: false,
    Year: null,
    Make: null,
    Model: null,
    Trim: null,
    YearLabel: null,
    MakeLabel: null,
    ModelLabel: null,
    TrimLabel: null,
    TireWidth: null,
    TireAspect: null,
    TireDiameter: null,
    TireName: null,
    ShirtSize: '',
    HatSize: '',
    JacketSize: '',
    AdditionalInfo: '',
    EnthusiastType: null,
    SessionId: '',
  },
  getters,
  mutations,
  actions,
});
